import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const DEMO_EVENT = "open-fit50-demo";
const VIDEO_URL = "/demo.webm";

export const VideoModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(DEMO_EVENT, show);
    return () => window.removeEventListener(DEMO_EVENT, show);
  }, []);

  useEffect(() => {
    if (open) window.__lenis?.stop();
    else window.__lenis?.start();
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="demo-video-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] grid place-items-center bg-obsidian/90 backdrop-blur-md p-4"
          onClick={() => setOpen(false)}
        >
          <motion.div
            initial={{ scale: 0.92, y: 30, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.95, y: 20, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="relative w-full max-w-4xl border border-volt/40 bg-carbon shadow-[0_0_80px_rgba(255,107,0,0.15)]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-5 py-3 border-b border-white/10">
              <span className="font-mono text-xs tracking-[0.25em] uppercase text-volt">
                10-Min Ignition — Session Preview
              </span>
              <button
                data-testid="demo-video-close-button"
                onClick={() => setOpen(false)}
                aria-label="Close video"
                className="text-neutral-400 hover:text-volt transition-colors"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="aspect-video w-full bg-obsidian">
              <video
                src={VIDEO_URL}
                autoPlay
                loop
                muted
                playsInline
                controls
                className="w-full h-full object-cover"
              />
            </div>
            <p className="px-5 py-3 font-mono text-[10px] tracking-widest uppercase text-neutral-500 border-t border-white/10">
              Sample session footage — Fit50 branded workouts ship at launch
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
